import VerticalSwiperV2 from './VerticalSwiper'

export default VerticalSwiperV2;